module.exports = __webpack_public_path__ + "img/Yarn_trading_1200x800.d588ea8a.png";